module.exports = __webpack_public_path__ + "img/contract-active.6a48ca03.svg";